/*=========================================================================================
  File Name: actions.js
  Description: Payment Actions
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/
import paymentsService from "../../../services/checkouts/commands";
import netsService from "../../../services/checkouts/queries";
import errorHandling from "../../../commons/ErrorHandling.js";

export default {
  async handleCheckoutAcceptAction({ commit, state }, payload) {
    let errorType = null;
    try {
      await paymentsService.handleCheckoutAccept(payload).then(response => {
        //console.log(response.data)
        commit("SET_CHECKOUT_ACCEPT_STATE", response.data);
      });
    } catch (err) {
      errorType = errorHandling.getErrorType(err);
    } finally {
      console.log(errorType);
      return errorType;
    }
  },

  async handleNetsCheckoutAcceptAction({ commit, state }, payload) {
    let errorType = null;
    try {
      await netsService.handleNetsCheckoutAccept(payload.paymentId).then(response => {
        if(response !== null && Object.keys(response).length > 0) {
          commit("SET_NETS_CHECKOUT_ACCEPT_STATE", response);
        }
        return errorType;
      });
    } catch (err) {
      console.log(err)
      errorType = errorHandling.getErrorType(err);
    } finally {
      console.log(errorType);
      return errorType;
    }
  },

  async handleNetsCheckoutAcceptRedirectAction({ commit, state }, payload) {
    let errorType = null;
    try {
      await netsService.handleNetsCheckoutAcceptRedirect(payload.paymentId).then(response => {
        console.log(response)
        commit("SET_NETS_CHECKOUT_ACCEPT_STATE", response);
      });
    } catch (err) {
      console.log(err)
      errorType = errorHandling.getErrorType(err);
    } finally {
      console.log(errorType);
      return errorType;
    }
  },

  async getSessionTokenWithAnonymousOrderAction({ commit, state }, payload) {
    console.log(payload)
    await paymentsService.getPaymentSession(payload).then(response => {
      console.log(response);
      commit("SET_SESSION_TOKEN_STATE", response.data);
    });
  },

  async getNetsSessionTokenWithAnonymousOrderAction({ commit, state }, payload) {
    console.log(payload)
    await paymentsService.getNetsPaymentSession(payload).then(response => {
      console.log(response);
      commit("SET_NETS_SESSION_TOKEN_STATE", response.data);
    });
  },

  async updateNetsSessionTokenWithAnonymousOrderAction( {commit, state }, payload) {
    console.log(payload);
    await paymentsService.updateNetsPaymentSession(payload.paymentId,payload).then(response => {
      console.log(response);
      commit('UPDATE_NETS_SESSION_TOKEN_STATE', response.data);
    })
  },

  async getPaymentDetailByIdAction({ commit, state }, payload ) {
    return await netsService.getPaymentDetailById(payload.paymentId).then(response => {
      if(response !== null && Object.keys(response).length > 0) {
        commit('SET_NETS_SESSION_TOKEN_STATE', response);
        commit('SET_CHARGED_AMOUNT_STATE', response);
        commit('cart/SET_CART_INFO_STATE', response.cart, {root : true } );
        commit('restaurants/SET_CURRENT_RESTAURANT_STATE', {'restaurantId' : response.cart.restaurantId}, {root : true });
      }
      return response;
    });
  }

  
};
